import React, { useEffect } from "react";
import {
  Check,
  Star,
  Users,
  Zap,
  Shield,
  Cloud,
  ArrowRight,
  Share2,
} from "lucide-react";
import PurchaseCreditsButton from "./Instagram/PurchaseCreditsButton";
import {
  CashfreePaymentCallback,
  CashfreeSuccessCallbackForCampaign,
  CreateInstaCampaignOrderApi,
  CreateInstaCreditsOrderApi,
} from "../Api/ApiEndPoints";

const CampaignPricingPage = () => {
  const plans = [
    {
      name: "Single License",
      price: 5000,
      description: "Perfect for individual creators and small businesses",
      features: [
        {
          text: "Up to 5 active campaigns",
          icon: <Zap className="w-5 h-5 text-blue-500" />,
        },
        {
          text: "Basic analytics and reporting",
          icon: <Star className="w-5 h-5 text-blue-500" />,
        },
        {
          text: "Standard support response time",
          icon: <Shield className="w-5 h-5 text-blue-500" />,
        },
        {
          text: "10GB cloud storage included",
          icon: <Cloud className="w-5 h-5 text-blue-500" />,
        },
        {
          text: "Single user account access",
          icon: <Users className="w-5 h-5 text-blue-500" />,
        },
      ],
      popular: false,
    },
    {
      name: "Multi License",
      price: 20000,
      description: "Ideal for teams and growing organizations",
      features: [
        {
          text: "Unlimited active campaigns",
          icon: <Zap className="w-5 h-5 text-blue-500" />,
        },
        {
          text: "Advanced analytics with custom reports",
          icon: <Star className="w-5 h-5 text-blue-500" />,
        },
        {
          text: "Priority 24/7 support response",
          icon: <Shield className="w-5 h-5 text-blue-500" />,
        },
        {
          text: "Unlimited cloud storage",
          icon: <Cloud className="w-5 h-5 text-blue-500" />,
        },
        {
          text: "Team collaboration features",
          icon: <Share2 className="w-5 h-5 text-blue-500" />,
        },
      ],
      popular: true,
    },
  ];

  useEffect(() => {
    //api to fetch plans
  }, []);

  return (
    <div className="bg-gray-50 min-h-screen py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Choose Your License
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Select the perfect plan for your needs. Upgrade or downgrade at any
            time.
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {plans.map((plan, index) => (
            <div
              key={plan.name}
              className={`relative bg-white rounded-2xl shadow-lg overflow-hidden transition-transform hover:scale-105 ${
                plan.popular
                  ? "border-2 border-blue-500"
                  : "border border-gray-100"
              }`}
            >
              {plan.popular && (
                <div className="absolute top-0 right-0 bg-blue-500 text-white px-4 py-1 rounded-bl-lg text-sm font-medium">
                  Popular
                </div>
              )}

              <div className="p-8">
                {/* Plan Header */}
                <div className="mb-6">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">
                    {plan.name}
                  </h3>
                  <p className="text-gray-600">{plan.description}</p>
                </div>

                {/* Price */}
                <div className="mb-8">
                  <p className="text-4xl font-bold text-gray-900">
                    ₹{plan.price.toLocaleString()}
                  </p>
                  <p className="text-gray-600 mt-1">per year</p>
                </div>

                {/* Features */}
                <ul className="space-y-4 mb-8">
                  {plan.features.map((feature, index) => (
                    <li key={index} className="flex items-start gap-3">
                      {feature.icon}
                      <span className="text-gray-700">{feature.text}</span>
                    </li>
                  ))}
                </ul>

                {/* CTA Button */}
                <PurchaseCreditsButton
                  planDetails={{
                    planType: index === 0 ? "SINGLE" : "MULTI",
                    prices: {
                      INR: plan.price * 100,
                    },
                  }}
                  endpoints={{
                    success: CashfreeSuccessCallbackForCampaign,
                    createOrder: CreateInstaCampaignOrderApi,
                  }}
                  component={
                    <button
                      className={`w-full py-3 px-6 rounded-lg font-medium flex items-center justify-center gap-2 transition-colors ${
                        plan.popular
                          ? "bg-blue-500 text-white hover:bg-blue-600"
                          : "bg-gray-100 text-gray-900 hover:bg-gray-200"
                      }`}
                    >
                      Get Started
                      <ArrowRight className="w-4 h-4" />
                    </button>
                  }
                />
                {/* <button
                  className={`w-full py-3 px-6 rounded-lg font-medium flex items-center justify-center gap-2 transition-colors ${
                    plan.popular
                      ? "bg-blue-500 text-white hover:bg-blue-600"
                      : "bg-gray-100 text-gray-900 hover:bg-gray-200"
                  }`}
                >
                  Get Started
                  <ArrowRight className="w-4 h-4" />
                </button> */}
              </div>
            </div>
          ))}
        </div>

        {/* Money Back Guarantee */}
        {/* <div className="text-center mt-12">
          <p className="text-gray-600">
            30-day money-back guarantee • Cancel anytime • 24/7 Support
          </p>
        </div> */}
      </div>
    </div>
  );
};

export default CampaignPricingPage;
